import { TextFieldField } from '@tm/shared-lib/src/field'
import React from 'react'
import { useI18N } from '../../hooks/useI18n'
import { useSurveyValue } from '../../hooks/useSurveyValue'
import { InputField } from '../field/InputField'

interface Props {
  field: TextFieldField
}

export function TextFieldQuestion({ field }: Props): JSX.Element {
  const [value, setValue] = useSurveyValue(field)
  const { lang } = useI18N()
  return (
    <InputField
      type="text"
      value={typeof value === 'string' ? value : ''}
      onValueChange={setValue}
      name={field.name}
      placeholder={field.placeholder && typeof field.placeholder[lang] === 'string' ? field.placeholder[lang] : ''}
    />
  )
}
